function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.81 2h8.37C19.83 2 22 4.17 22 7.81v8.37c0 3.64-2.17 5.81-5.81 5.81H7.81C4.17 22 2 19.83 2 16.19V7.81C2 4.17 4.17 2 7.81 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 18.58c-3.17 0-5.75-2.58-5.75-5.75 0-1.14.33-2.25.97-3.19.23-.34.7-.44 1.04-.21.34.23.44.7.21 1.04a4.26 4.26 0 003.54 6.61 4.26 4.26 0 004.25-4.25c0-2.24-1.74-4.08-3.94-4.24l.41.3c.33.24.41.71.16 1.05a.75.75 0 01-1.05.16L9.9 8.69a.769.769 0 01-.18-.18.138.138 0 01-.03-.04.917.917 0 01-.09-.23.942.942 0 01-.01-.29l.03-.12c.02-.07.06-.13.1-.2.02-.01.04-.03.06-.05l1.66-1.9c.27-.31.75-.34 1.06-.07.31.27.34.75.07 1.06l-.37.43a5.76 5.76 0 015.56 5.75c-.01 3.15-2.59 5.73-5.76 5.73z"
})));